/**
 * Read-side normalization for a test's `intent` (#2102).
 *
 * The intent taxonomy collapsed from five kinds to three: `validation`
 * and `error-handling` folded into `negative` (they overlapped it,
 * breaking MECE). New rows only ever carry `happy-path` / `negative` /
 * `edge-case`, but rows written before the collapse may still hold the
 * old values — by decision there is no back-fill.
 *
 * Every display or picker that reads a stored intent runs it through
 * here so a legacy value renders as the kind it now IS (Negative),
 * rather than as a broken/blank control or an untinted badge. The stored
 * value is untouched until that row is next saved or re-read.
 *
 * Returns `undefined` for a null/absent/unrecognized value so the caller
 * can fall back to a neutral display.
 */
import type { TestIntent } from '@/types'

export function normalizeIntent(value: string | null | undefined): TestIntent | undefined {
  switch (value) {
    case 'happy-path':
    case 'negative':
    case 'edge-case':
      return value
    case 'validation':
    case 'error-handling':
      // Folded into Negative by #2102 — show legacy rows as what they now are.
      return 'negative'
    default:
      return undefined
  }
}
